"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var extend_1 = require("fast-af/extend");
var HoverSensor_1 = require("libreact/lib/HoverSensor");
var Ripple_1 = require("../../../atoms/Ripple");
var css_1 = require("../../../css");
var theme_1 = require("../../../theme");
var SpinnerCircle_1 = require("../../../atoms/SpinnerCircle");
var h = React.createElement;
var styles = css_1.sheet({
    button: {
        d: 'inline-flex',
        w: 'auto',
        td: 'none',
        boxSizing: 'border-box',
        justifyContent: 'center',
        alignItems: 'center',
        fz: '14px',
        ff: theme_1.theme.font.altLite.ff,
        fw: theme_1.theme.font.altLite.fw,
        letterSpacing: '0.14px',
        lh: '24px',
        trs: 'background .2s, box-shadow .2s, color .2s',
        mar: 0,
        bdrad: '3px',
        bd: 0,
        pad: '0px 15px',
        minWidth: '50px',
        cur: 'pointer',
        '&:hover': {
            boxShadow: "0 0 0 3px " + theme_1.theme.color6[0],
        },
        '&.color:hover': {
            boxShadow: 'none',
            'svg,svg path': {
                fill: '#fff',
            },
        },
        '&:disabled': {
            boxShadow: 'none',
        },
        '&:focus': {
            boxShadow: "0 0 0 3px " + theme_1.theme.blue,
        },
    },
    icon: {
        alignItems: 'center',
        d: 'flex',
    },
}, 'Button');
var Button = function (props) {
    var block = props.block, children = props.children, color = props.color, disabled = props.disabled, icon = props.icon, ghost = props.ghost, href = props.href, lite = props.lite, loading = props.loading, outline = props.outline, positive = props.positive, primary = props.primary, simple = props.simple, size = props.size, _a = props.style, style = _a === void 0 ? {} : _a, upper = props.upper, onClick = props.onClick;
    return h(HoverSensor_1.HoverSensor, { bond: true }, function (_a) {
        var bond = _a.bond, isHover = _a.isHover;
        var tag = 'button';
        if (loading) {
            disabled = true;
            icon = React.createElement(SpinnerCircle_1.default, null);
        }
        if (ghost) {
            outline = true;
            lite = true;
        }
        var buttonStyle = {
            background: positive
                ? theme_1.theme.color1[1]
                : primary
                    ? theme_1.theme.color2[1]
                    : lite
                        ? 'transparent'
                        : 'rgba(127,127,127,.2)',
            color: primary || positive ? '#fff' : theme_1.theme.slate,
            height: size * 8 + 40 + "px",
            boxSizing: 'border-box',
        };
        if (upper) {
            buttonStyle.textTransform = 'uppercase';
        }
        var buttonProps = {
            className: (props.className || '') + styles.button,
            onClick: onClick,
            style: buttonStyle,
        };
        if (disabled) {
            buttonProps.disabled = true;
            buttonStyle.opacity = 0.7;
            buttonStyle.cursor = 'default';
        }
        else {
            if (color) {
                buttonProps.className += ' color';
            }
        }
        if (outline) {
            buttonStyle.border = '1px solid rgba(0,0,0,.1)';
        }
        if (href) {
            tag = 'a';
            buttonProps.href = href;
        }
        if (block) {
            buttonStyle.width = '100%';
        }
        var buttonElement = null;
        if (simple) {
            buttonStyle.border = "1px solid " + theme_1.theme.color1[3];
            buttonStyle.background = '#fff';
            buttonStyle.color = theme_1.theme.color1[3];
        }
        if (isHover && !disabled) {
            buttonStyle.color = primary || positive || color ? '#fff' : theme_1.theme.slate;
            buttonStyle.background = color
                ? color
                : positive
                    ? theme_1.theme.color1[0]
                    : primary
                        ? theme_1.theme.color2[2]
                        : 'rgba(180,180,180,.2)';
        }
        if (icon) {
            var iconProps = {
                className: styles.icon,
                style: {},
            };
            if (children) {
                iconProps.style.paddingRight = '8px';
            }
            buttonElement = h(tag, extend_1.extend(buttonProps, bond), h('span', iconProps, icon), children);
        }
        else {
            buttonElement = h(tag, extend_1.extend(buttonProps, bond), children);
        }
        extend_1.extend(buttonStyle, style);
        return h(Ripple_1.Ripple, {
            ms: block ? 400 : 1000,
            color: disabled ? 'transparent' : primary || positive || color ? 'rgba(255,255,255,.85)' : 'rgba(0,0,0,.1)',
        }, buttonElement);
    });
};
Button.defaultProps = {
    size: 0,
};
exports.default = Button;
//# sourceMappingURL=index.js.map